import Select from "react-select";
import { useEffect, useState } from "react";

import BASEURL from "../../pages/Utils/Baseurl";
import axios from "axios";

import MaterialButton from "../../components/MaterialButton/index.js";
import { Card, CardContent, Checkbox, Grid2, Typography } from "@mui/material";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import MaterialSelect from "../../components/MasterSelect/index.js";
import { useLoading } from "../../context/loading.jsx";
import MaterialBox from "../../components/MaterialBox/index.js";
import MaterialTypography from "../../components/MaterialTypography/index.js";
import ConfirmationDialog from "../../components/Dialog/ConfirmationDialog";
import Swal from "sweetalert2";
const allrolepermission = `
query GetRolePermissionByRoleId($roleId: ID!) { 
  getRolePermissionByRoleId(roleId: $roleId) { 
    data { 
      id 
      role { 
        id 
      } 
      component{
        componentName
        id
        module{
          moduleName
          id
    			app{
            appName
            id
          } 
        }
      } 
      canAccess 
    } 
    success 
    error 
    message 
  } 
}
`;
const updaterolepermission = `mutation UpdateRolesPermission($input: RolesPermissionUpdateInput!) {
  updateRolesPermission(input: $input) {
    success
    message
  }
}`;
const Role_Permit = () => {
  const [tenants, settenants] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [role, setrole] = useState(null);
  const [allRole, setAllRole] = useState("");
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const { circleLoading, setCirleLoading } = useLoading();
  const [initialValues, setinitialvalues] = useState({
    input: {
      roleId: "",

      appMerge: [
        {
          componentId: [],
          canAccess: [],
        },
      ],
    },
  });

  const processData = (apiData) => {
    const groupedData = {};

    apiData.forEach((item) => {
      const { module, componentName, id } = item;

      setinitialvalues((prev) => ({
        ...prev,
        input: {
          ...prev.input,
          appMerge: [
            {
              componentId: [...prev.input.appMerge[0].componentId, id],
              canAccess: [...prev.input.appMerge[0].canAccess, false],
            },
          ],
        },
      }));

      if (!groupedData[module?.app?.appName]) {
        groupedData[module?.app?.appName] = {
          appId: module?.app?.id,
          modules: {},
        };
      }

      if (!groupedData[module?.app?.appName].modules[module?.moduleName]) {
        groupedData[module?.app?.appName].modules[module?.moduleName] = {
          moduleId: module?.id,

          components: [],
        };
      }

      groupedData[module?.app?.appName].modules[
        module?.moduleName
      ].components.push({
        componentId: id,
        componentName: componentName,
      });
    });

    return Object.entries(groupedData).map(([appName, appData]) => ({
      appName,
      appId: appData.appId,
      modules: Object.entries(appData.modules).map(
        ([moduleName, moduleData]) => ({
          moduleName,
          moduleId: moduleData.moduleId,
          components: moduleData.components,
        })
      ),
    }));
  };

  //handlecheck boxes
  const handlecheckstatus = (id) => {
    if (selectedcomponent.includes(id)) {
      setselectedcomponent((prev) => {
        const updatedcomponent = [...prev];
        const newcomponent = updatedcomponent.filter((comp) => comp !== id);

        return newcomponent;
      });

      const updatedinitialvalues = [
        ...initialValues.input.appMerge[0].componentId,
      ];
    } else {
      setselectedcomponent((prev) => [...prev, id]);
    }
  };
  const getroledata = async () => {
    setCirleLoading(true);
    const query = `query{
allRoles{
 data{
   id
   role
   description
 }
}
}`;
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      let result = response.data.data.allRoles;

      const filterdata = result[0].data.filter(
        (item) => item?.role !== "admin"
      );
      setrole(filterdata);
    } catch (error) {
    } finally {
      setCirleLoading(false);
    }
  };
  useEffect(() => {
    getroledata();
  }, []);
  // getting role array
  useEffect(() => {
    const fetchrole = async () => {
      setCirleLoading(true);
      const getallroles = `query allComponent{
  allComponents{
    data {
      id
      componentName
      module {
        id
        moduleName
        app{
          id
          appName
        }
      }
    }
    success
    error
    message
  }
}`;
      try {
        const response = await axios.post(
          BASEURL,
          {
            query: getallroles,
            variables: { id: 1 },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const filter = processData(response?.data?.data?.allComponents?.data);

        setFilteredData(filter);

        const updatedoption = response.data.data.allComponents[0].data.map(
          (role) => ({
            value: role.id,
            label: role.role,
            tooltip: role.description,
          })
        );
        setoptions(updatedoption);
      } catch (error) {
      } finally {
        setCirleLoading(false);
      }
    };

    fetchrole();
  }, []);

  const [options, setoptions] = useState([]);

  const [selectedcomponent, setselectedcomponent] = useState([]);

  useEffect(() => {
    const fetchallroles = async () => {
      setCirleLoading(true);
      try {
        const response = await axios.post(
          BASEURL,
          {
            query: allrolepermission,
            variables: { roleId: allRole.value },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.data.getRolePermissionByRoleId.data) {
          const unproceesedarray =
            response.data.data.getRolePermissionByRoleId.data;

          const processedarray = unproceesedarray.filter(
            (component) => component.canAccess
          );

          const choosedcomponents = processedarray.map((component) => {
            return component.component.id;
          });

          setselectedcomponent(choosedcomponents);
        } else {
          setselectedcomponent([]);
        }
      } catch (error) {
      } finally {
        setCirleLoading(false);
      }
    };

    if (allRole) {
      fetchallroles();
    }
  }, [allRole]);


  //handlesubmit
  const handlesubmit = () => {
    // setPageState({
    //   ...pageState,
    //   state: "submitting",
    // });
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onAddRoll();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const onAddRoll = async () => {
    setCirleLoading(true);

    const updatedinitialvalues = { ...initialValues };
    updatedinitialvalues.input.roleId = allRole?.value;

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: updaterolepermission,
          variables: updatedinitialvalues,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.data?.updateRolesPermission?.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: response?.data?.data?.updateRolesPermission?.message,
          showConfirmButton: false,
          timer: 2500,
        });
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: response?.data?.data?.updateRolesPermission?.message,
          showConfirmButton: false,
          timer: 2500,
        });
      }
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
    } catch (err) {
    } finally {
      setCirleLoading(false);
    }
  };

  useEffect(() => {
    if (selectedcomponent) {
      const indextoupdate = [];

      selectedcomponent.forEach((component) => {
        indextoupdate.push(
          initialValues.input.appMerge[0].componentId.indexOf(component)
        );
      });

      const duplicatecanaccess = [...initialValues.input.appMerge[0].canAccess];

      const updatedcanaccess = duplicatecanaccess.map((canaccess, index) =>
        indextoupdate.includes(index) ? true : false
      );
      setinitialvalues((prev) => ({
        ...prev,
        input: {
          ...prev.input,
          appMerge: [
            {
              componentId: [...prev.input.appMerge[0].componentId],
              canAccess: updatedcanaccess,
            },
          ],
        },
      }));
    }
  }, [selectedcomponent]);

  const handleChanges = (e) => {
    setAllRole(e);
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Grid2
        size={{ xs: 12, md: 12, lg: 12 }}
        container
        spacing={1}
        sx={{ display: "flex", flexDirection: "column" }}
      >
        <Grid2 size={{ xs: 12, md: 12, lg: 3 }}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Role Name <span style={{ color: "red" }}>*</span>
            </MaterialTypography>
          </MaterialBox>
          <MaterialSelect
            name="role"
            value={allRole}
            onChange={handleChanges}
            options={role?.map((role) => ({
              value: role.id,
              label: role.role,
            }))}
            isClearable
          ></MaterialSelect>
        </Grid2>

        {allRole?.value &&
          filteredData.map(
            (app, appInd) =>
              role && (
                <Card
                  key={appInd}
                  sx={{
                    p: 5,
                    paddingLeft: 15,
                    borderRadius: 2,
                    width: "70vw",
                    display: "flex",
                    alignItems: "flex-end",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <CardContent sx={{ position: "relative", right: "50px" }}>
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: "bold", color: "#1976d2" }}
                    >
                      {app.appName}
                    </Typography>

                    {app.modules.map((module, moduleInd) => (
                      <Card
                        key={moduleInd}
                        sx={{
                          my: 2,
                          p: 2,
                          backgroundColor: "#f5f5f5",
                          borderRadius: 2,
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          sx={{ fontWeight: "bold", color: "#424242", mb: 1 }}
                          key={module.moduleId}
                        >
                          {module.moduleName}
                        </Typography>

                        <Grid2 container spacing={2}>
                          {module.components.map((component, compInd) => (
                            <Grid2
                              key={compInd}
                              xs={12}
                              md={4}
                              sx={{ display: "flex", alignItems: "center" }}
                            >
                              <Checkbox
                                checked={selectedcomponent.includes(
                                  component.componentId
                                )}
                                onChange={() =>
                                  handlecheckstatus(component.componentId)
                                }
                                key={component.componentId}
                                sx={{
                                  color: "#424242", // Dark color for default state
                                  "&.Mui-checked": {
                                    color: "#1976d2", // Change color when checked
                                  },
                                  "& .MuiSvgIcon-root": {
                                    fontSize: "18px",
                                    border: "1px solid #424242", // Dark border
                                    borderRadius: "4px", // Optional: Rounded edges
                                  },
                                }}
                              />

                              <Typography
                                variant="body1"
                                sx={{ fontSize: "15px" }}
                              >
                                {component.componentName}
                              </Typography>
                            </Grid2>
                          ))}
                        </Grid2>
                      </Card>
                    ))}
                  </CardContent>
                </Card>
              )
          )}

        <Grid2 size={{ xs: 12, md: 12, lg: 3 }}>
          {/* <Button onClick={handlesubmit}>Submit</Button> */}

          {allRole?.value && (
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              // disabled={
              //   !checkAllFields() || pageState.state === "submitting"
              // }
              // startIcon={<AddIcon />}
              onClick={handlesubmit}
            >
              Submit
            </MaterialButton>
          )}
        </Grid2>
      </Grid2>
    </DashboardLayout>
  );
};
export default Role_Permit;
